export const EmptyFavoritesComponent = () => {
    return (
        <div style={{ marginLeft: "3.5rem" }}>
            <div
                style={{
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    height: "45rem",
                    borderRadius: "2rem",
                    overflow: "hidden",
                    width: "40rem",
                    maxWidth: "600px",
                }}
            >
            </div>
        </div>

    );
};
